<template>
  <div class="container">
    <section class="search-input-wrapper">
      <div class="mini_header">
        <div class="form_">
          <p class="city_label">Choose your City</p>
          <select
            :value="selectedCity"
            style="
              font-size: 14px;
              border: 3px solid #01e069;
              color: #676767;
              padding: 2px 1px;
            "
            @change="onChangeCity($event)"
            class="selection pad-select"
          >
            <option disabled value="">Please select a city</option>
            <option
              v-for="option in cities"
              v-bind:key="option.city_id"
              :value="option.city_id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <search-input-component @search-input-changed="onSearchInputChanged" />
      </div>
    </section>
    <loading-container
      :loading="loading"
      :error-loading="errorLoading"
      :loaded="!loading && !errorLoading"
      :retry="() => {}"
    >
      <div class="routes-wrapper" v-if="routesData.length">
        <section class="route-box" :key="route.id" v-for="route in routesData">
          <route-box :routeData="route" @show-itinerary="showItinearary" />
        </section>
      </div>
      <div class="routes-wrapper centeralize empty-data" v-else>
        <div style="margin: 0 auto">
          <span v-if="!routes || !routes.length"> No routes found</span>
          <span
            v-else-if="
              routes &&
              routes.length &&
              (!routesData || !routesData.length) &&
              searchTerm
            "
          >
            No route matches the search
          </span>
          <span v-else> No data </span>
        </div>
      </div>
      <section
        class="pagination-wrapper"
        v-if="routesData.length > 10 && !searchTerm.length && searchTerm.length < 1"
      >
        <pagination
          @next-page="gotoNextPage"
          @previous-page="gotoPreviousPage"
          :perPage="pagination.perPage"
          :page="pagination.page"
          :isLastPage="!routes || !routes.length"
        />
      </section>
    </loading-container>
  </div>
</template>
<script>
import RouteBox from "./RouteBox.vue";
import SearchInputComponent from "./SearchInputComponent.vue";
import Pagination from "./Pagination.vue";
import axios from "@/services/axios";
import _ from "lodash";
import LoadingContainer from "./LoadingContainer.vue";

const PAGE_LIMIT = 50;

export default {
  components: { RouteBox, SearchInputComponent, Pagination, LoadingContainer },
  props: {
    routes: Array,
    cities: Array,
    selectedCity: [String, Number]
  },
  data() {
    return {
      routesData: [],
      selected: "",
      routesDataFromServer: [],
      unPaginatedRoutesData: [],
      searchTerm: "",
      pagination: {
        perPage: PAGE_LIMIT,
        page: 1,
      },
      loading: false,
      errorLoading: false,
    };
  },
  methods: {
    onSearchInputChanged(searchTerm) {
      if (searchTerm) {
        this.pagination.perPage = 200;
        this.getRoutesDataFromServer(searchTerm);
      } else {
        this.pagination.perPage = PAGE_LIMIT;
        const unPaginatedRoutesData = (this.unPaginatedRoutesData =
          this.routes);
        this.routesData = this.paginate(
          unPaginatedRoutesData,
          this.pagination.page,
          this.pagination.perPage
        );
      }
      this.searchTerm = searchTerm;
    },
    getRoutesDataFromServer(searchTerm) {
      this.loading = true;

      axios
        .post(`routes/search`, {
          search: searchTerm,
          limit: 100,
        })
        .then((res) => {
          let dataResp = res.data;
          const data = _.uniqBy(dataResp, "id");
          this.routesData = this.paginate(data, 1, this.pagination.perPage);
        })
        .catch((ERR) => {
          if (
            ERR.response.data.code &&
            ERR.response.data.code === "ItemNotFound"
          ) {
            this.routesData = [];
          }
        })
        .finally(() => (this.loading = false));
    },
    gotoNextPage(page) {
      const nextPage = (this.pagination.page = page + 1);
      this.$emit("next-page", nextPage);
      this.loading = true;
    },
    gotoPreviousPage(page) {
      const previousPage = (this.pagination.page = page - 1);
      this.$emit("previous-page", previousPage);
      this.loading = true;
    },
    paginate(list, page, perPage) {
      const data = list;
      const startIdx = perPage * (page - 1);
      const endIdx = startIdx + perPage;
      this.pagination.page = page;
      this.pagination.count = (data && data.length) || 0;
      return data.slice(startIdx, endIdx);
    },
    showItinearary(e) {
      return this.$emit("show-itinerary", e);
    },
    handleRoutesDataChange(newRouteData, page = 1) {
      this.unPaginatedRoutesData = newRouteData;
      this.routesData = newRouteData;
      return page;
    },
    async onChangeCity(event) {
      this.$emit("selected-city", event.target.value);
    },
  },
  watch: {
    routes(newRoutes) {
      this.loading = false;
      const unPaginatedRoutesData = newRoutes;
      this.handleRoutesDataChange(unPaginatedRoutesData, this.pagination.page);
    },
  },
  created() {
    const unPaginatedRoutesData = this.routes;
    this.unPaginatedRoutesData = unPaginatedRoutesData;
    this.handleRoutesDataChange(unPaginatedRoutesData);
  },
  $emit: ["show-itenerary", "next-page", "previous-page", "selected-city"],
};
</script>
<style scoped>
.routes-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  min-height: 272px;
  padding: 0 10px;
  justify-content: center;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  min-height: 500px;
}
.route-box {
  margin: 15px 25px 30px 5px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  padding: 7px 0 8px 0;
}
.centeralize {
  display: flex;
  justify-content: center;
  flex-direction: row;
}
.empty-data {
  color: #676767;
  font-size: 14px;
}
.pagination-wrapper {
  width: 100%;
}
.mini_header {
  display: flex;
  flex-flow: row;
  width: 100%;
}
.form_ {
  height: 10%;
  width: 80%;
  font-size: 13px;
  margin: auto;
  margin-bottom: 40px;
  margin-right: 20px;
  margin-top: -4%;
}
.selection {
  margin: auto;
  border: 1px solid #6f7873;
  border-radius: 5px;
  outline: none;
}
.city_label {
  color: #01e069;
  font-weight: bold;
  font-size: 13px;
}
.pad-select {
  height: 40px;
  border: 2px solid #01e069;
}
@media only screen and (max-width: 768px) {
  .routes-wrapper {
    justify-content: space-between;
  }
  .route-box {
    margin-left: 5px;
    margin-right: 5px;
    min-width: 220px;
  }
}

@media only screen and (max-width: 480px) {
  .routes-wrapper {
    flex-direction: column;
  }
  .route-box {
    margin-left: 5px;
    margin-right: 5px;
    width: 100%;
  }
  .search-input-wrapper {
    width: 100%;
  }
  .mini_header {
    flex-flow: column;
  }
  .form_ {
    height: 10%;
    width: 100%;
    margin: auto;
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 5%;
  }
}
</style>